// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */

import React from 'react';

import {
  Analytics,
  formatContainers,
  tracingCallback,
} from '@trello/atlassian-analytics';
import { isEmbeddedInAtlassian } from '@trello/browser';
// eslint-disable-next-line no-restricted-imports
import $ from '@trello/jquery';
import { BoardHeaderTestIds } from '@trello/test-ids';

// eslint-disable-next-line no-restricted-imports
import { Controller } from 'app/scripts/controller';
import { setBoardLocation } from 'app/scripts/controller/setBoardLocation';
import { Auth } from 'app/scripts/db/Auth';
import { BoardHeaderAllMembersView } from 'app/scripts/views/board/BoardHeaderAllMembersView';
import { maybeDisplayMemberLimitsError } from 'app/scripts/views/board-menu/MemberLimitsError';
import { Dialog } from 'app/scripts/views/lib/Dialog';
import { DragSort } from 'app/scripts/views/lib/DragSort';
import { PopOver } from 'app/scripts/views/lib/PopOver';
import { MemberBoardProfileView } from 'app/scripts/views/member/MemberBoardProfileView';
import { MemberOnBoardView } from 'app/scripts/views/member-menu-profile/MemberOnBoardView';
import {
  dialogProps,
  LazyBoardInviteModal,
} from 'app/src/components/BoardInviteModal';
import { ComponentWrapper } from 'app/src/components/ComponentWrapper';
import { stopPropagationAndPreventDefault } from 'app/src/stopPropagationAndPreventDefault';

// eslint-disable-next-line @trello/no-module-logic
const MAX_FACEPILE_SIZE = isEmbeddedInAtlassian() ? 2 : 5;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const onMemberAdd = function (this: any) {
  return this.renderBoardHeaderFacepileDebounced();
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const renderBoardHeaderFacepile = function (this: any) {
  // eslint-disable-next-line @trello/enforce-variable-case
  const $target = $('.js-fill-facepile', this.$el);
  let visibleMembers = this.model.orderedVisibleMembers();
  const numMembers = visibleMembers.length;
  visibleMembers = visibleMembers.slice(0, MAX_FACEPILE_SIZE);
  const overflowMemberCount = numMembers - MAX_FACEPILE_SIZE;

  if (overflowMemberCount > 0) {
    $('.js-fill-board-member-count', this.$el).text(`+${overflowMemberCount}`);
  } else {
    $('.js-fill-board-member-count', this.$el).text('');
  }

  let z = visibleMembers.length;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const subviews = visibleMembers.map((member: any) =>
    this.subview(MemberOnBoardView, member, {
      board: this.model,
      zIndex: z--,
      testId: BoardHeaderTestIds.FacepileMember,
    }),
  );

  if ($target.length > 0) {
    this.ensureSubviews(subviews, $target);
  }

  this.defer(() => {
    // Disallow adding members to cards from facepile when board is in template mode
    if (!this.model.isTemplate()) {
      DragSort.refreshDraggableBoardMembers();
    }
  });

  return this;
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const openAllMembers = function (this: any, e: any) {
  // activated only when there's member overflow from facepile
  stopPropagationAndPreventDefault(e);

  Analytics.sendClickedButtonEvent({
    buttonName: 'allBoardMembersButton',
    source: 'boardScreen',
  });

  return PopOver.toggle({
    elem: $('.js-open-show-all-board-members', this.$el),
    view: BoardHeaderAllMembersView,
    options: {
      model: this.model,
      modelCache: this.modelCache,
    },
  });
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const openAddMembers = function (this: any, e: any) {
  if (e) {
    stopPropagationAndPreventDefault(e);
  }

  const idOrganization = this.model.getOrganization()?.id;
  Analytics.sendClickedButtonEvent({
    buttonName: 'shareButton',
    source: 'boardScreen',
    containers: formatContainers({
      idBoard: this.model.id,
      idOrganization,
      idWorkspace: idOrganization,
    }),
  });

  Dialog.show({
    reactElement: (
      <ComponentWrapper>
        <LazyBoardInviteModal
          idBoard={this.model.id}
          idOrg={idOrganization}
          onClose={Dialog.hide}
        />
      </ComponentWrapper>
    ),
    ...dialogProps,
  });
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const joinBoard = function (this: any, e: any) {
  stopPropagationAndPreventDefault(e);

  Analytics.sendClickedButtonEvent({
    buttonName: 'joinBoardButtonV2',
    source: 'boardScreen',
  });

  if (maybeDisplayMemberLimitsError($(e.target), this.model, Auth.me())) {
    return;
  }

  const traceId = Analytics.startTask({
    taskName: 'edit-board/members/join',
    source: 'boardScreen',
  });

  $('.js-join-board', this.$el).remove();

  this.model.joinBoard(
    traceId,
    tracingCallback(
      {
        taskName: 'edit-board/members/join',
        source: 'boardScreen',
        traceId,
      },
      (error, response) => {
        if (response) {
          Analytics.sendTrackEvent({
            action: 'joined',
            actionSubject: 'board',
            source: 'boardScreen',
            containers: {
              board: {
                id: this.model.id,
              },
              organization: {
                id: this.model.getOrganization()?.id,
              },
            },
            attributes: {
              taskId: traceId,
            },
          });
        }
      },
    ),
  );
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const showMemberProfile = function (this: any, member: any) {
  Controller.saveMemberBoardProfileLocation(member, this.model.id);
  if (!Dialog.isVisible) {
    Dialog.show({
      view: new MemberBoardProfileView({
        model: member,
        board: this.model,
        modelCache: this.modelCache,
      }),
      maxWidth: 500,
      hide: () => setBoardLocation(this.model.id),
    });
  }
};
